var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Marked } from '@ts-stack/markdown';
let BoostMarkdown = class BoostMarkdown extends LitElement {
    constructor() {
        super(...arguments);
        this.elementId = '';
        this.markdown = '';
    }
    static get is() {
        return 'boost-markdown';
    }
    static get styles() {
        return css ``;
    }
    /** @override */ render() {
        return html ` <div id="${this.elementId}"></div>`;
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'markdown':
                    this._markdownObserver();
                    break;
            }
        });
        super.updated(changedProperties);
    }
    _markdownObserver() {
        if (!this.shadowRoot || !this.elementId) {
            return;
        }
        const containerElement = this.shadowRoot.getElementById(this.elementId);
        if (!containerElement) {
            return;
        }
        if (!this.markdown) {
            containerElement.innerHTML = '';
        }
        else {
            containerElement.innerHTML = Marked.parse(this.markdown);
        }
    }
};
BoostMarkdown._deps = [Marked];
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], BoostMarkdown.prototype, "elementId", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], BoostMarkdown.prototype, "markdown", void 0);
BoostMarkdown = __decorate([
    customElement(BoostMarkdown.is)
], BoostMarkdown);
export { BoostMarkdown };
